// IMPORTS

// local
import { VOTING_ESCROW_STRINGS } from "./governanceConfig"
import VotingEscrow from "./votingEscrow"

// global
import { FIXED_3_SCALE_FACTOR, FIXED_12_SCALE_FACTOR, SECONDS_PER_YEAR } from "../../globals"

// external
import algosdk, { Algodv2, LogicSigAccount, decodeAddress } from "algosdk"

function concatArrays(arrays : Uint8Array[]) {
  // sum of individual array lengths
  let totalLength = arrays.reduce((acc, value) => acc + value.length, 0);

  if (!arrays.length) return null;

  let result = new Uint8Array(totalLength);

  // for each array - copy it over result
  // next array is copied right after the previous one
  let length = 0;
  for(let array of arrays) {
    result.set(array, length);
    length += array.length;
  }

  return result;
}

export default class UserAirdropState {
  public address: string
  public govAssetId: number
  public decodedAddress: Uint8Array
  public dropLsig: LogicSigAccount
  public lockLsig: LogicSigAccount

  public unlockedAirdrop: number
  public lockedAirdrop: number

  constructor(address: string, govAssetId: number) {
    this.address = address
    this.govAssetId = govAssetId
    this.decodedAddress = decodeAddress(this.address).publicKey
    this.dropLsig = this.getDropLogicSig()
    this.lockLsig = this.getLockLogicSig()
  }
  
  async loadState(algod: Algodv2) {
    try {
      this.unlockedAirdrop = (await algod.accountAssetInformation(this.dropLsig.address(), this.govAssetId).do())["asset-holding"].amount
    } catch (error) {
      this.unlockedAirdrop = 0
    }
    try {
      this.lockedAirdrop = (await algod.accountAssetInformation(this.lockLsig.address(), this.govAssetId).do())["asset-holding"].amount
    } catch (error) {
      this.lockedAirdrop = 0
    }
  }

  getDropLogicSig(): LogicSigAccount {
    let lsigPart1 = new Uint8Array([6, 32, 1, 1, 38, 2, 32])
    let lsigPart2 = new Uint8Array([32, 137, 122, 169, 64, 134, 17, 157, 219, 62, 52, 240, 127, 92, 157, 120, 248, 16, 227, 99, 74, 225, 34, 42, 156, 214, 2, 118, 99, 110, 253, 168, 58, 49, 32, 50, 3, 18, 68, 49, 16, 34, 18, 64, 0, 49, 49, 16, 129, 4, 18, 64, 0, 1, 0, 49, 32, 50, 3, 18, 68, 49, 20, 49, 0, 18, 49, 20, 40, 18, 17, 68, 49, 20, 40, 18, 64, 0, 8, 49, 21, 50, 3, 18, 68, 34, 67, 49, 21, 40, 18, 68, 66, 255, 246, 49, 9, 41, 18, 68, 49, 7, 41, 18, 68, 34, 67])
    let lsigBytes = concatArrays([lsigPart1, this.decodedAddress, lsigPart2])
    return new LogicSigAccount(lsigBytes)
  }
  
  getLockLogicSig(): LogicSigAccount {
    let lsigPart1 = new Uint8Array([6, 32, 1, 1, 38, 2, 32, 199, 236, 238, 162, 167, 166, 41, 228, 253, 192, 209, 28, 184, 221, 184, 171, 137, 164, 82, 233, 16, 35, 65, 58, 200, 114, 122, 22, 9, 11, 245, 115, 32, 137, 122, 169, 64, 134, 17, 157, 219, 62, 52, 240, 127, 92, 157, 120, 248, 16, 227, 99, 74, 225, 34, 42, 156, 214, 2, 118, 99, 110, 253, 168, 58, 49, 32, 50, 3, 18, 68, 49, 16, 34, 18, 64, 0, 152, 49, 16, 129, 4, 18, 64, 0, 1, 0, 49, 32, 50, 3, 18, 68, 49, 20, 49, 0, 18, 49, 20, 40, 18, 17, 68, 49, 20, 40, 18, 64, 0, 8, 49, 21, 50, 3, 18, 68, 34, 67, 49, 21, 40, 18, 68, 49, 22, 34, 8, 56, 0, 128, 32])
    let lsigPart2 = new Uint8Array([18, 68, 49, 22, 34, 8, 56, 16, 129, 6, 18, 68, 49, 22, 34, 8, 56, 24, 129, 237, 192, 187, 173, 3, 18, 68, 49, 22, 34, 8, 56, 25, 129, 0, 18, 68, 49, 22, 34, 8, 57, 26, 0, 128, 1, 108, 18, 68, 49, 22, 34, 8, 57, 26, 1, 23, 129, 128, 156, 181, 7, 18, 68, 66, 255, 143, 49, 9, 41, 18, 68, 49, 7, 41, 18, 68, 34, 67])
    let lsigBytes = concatArrays([lsigPart1, this.decodedAddress, lsigPart2])
    return new LogicSigAccount(lsigBytes)
  }
}
